export const ComplainRegistred = "Užregistruota";
export const ComplainProcessed = "Sprendžiama";
export const ComplainBlocked = "Laukiama";
export const ComplainClosed = "Išspręsta";


// WEBPACK FOOTER //
// ./src/constants/states.js